<mat-card class="daxa-card profile-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mt-0 mb-0">Informations du Profile</h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ul class="info-list pr-0 pl-0 mb-0 mt-0 list-unstyled">
            <li>
                <span class="text-body">ID:</span> {{ user.id || 'N/A' }}
            </li>
            <li>
                <span class="text-body">Nom complet:</span> {{ user.name || 'N/A' }}
            </li>
            <li>
                <span class="text-body">E-mail:</span> {{ user.email || 'N/A' }}
            </li>
            <li *ngIf="user.roles">
                <span class="text-body">Rôle:</span> {{ user.roles ? mapRole(user.roles) : 'Utilisateur' }}
            </li>
            <li *ngIf="!user.roles">
                <span class="text-body">Rôle:</span> Utilisateur
            </li>
        </ul>
    </mat-card-content>
</mat-card>
